import dva from 'dva';
import createLoading from 'dva-loading';

// import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.less';

// model
import modelGlobal from './models/global';
import modelImport from './models/imports';
import modelMenu from './models/menu';
import modelSetting from './models/setting';
import modelAuth from './models/auth';
import modelUser from './models/user';
import modelProduct from './models/product';
import modelVouchers from './models/vouchers';
import modelGroup from './models/group';
import modelPartners from './models/partners';
import modelCategories from './models/categories';
import modelBanner from './models/banner';

/* PLOP_INJECT_IMPORT */
import modelModel from './models/model';
import modelAction from './models/action';
import modelConfig from './models/config';
import modelCronLogs from './models/cronLogs';
import modelCron from './models/cron';
import modelLog from './models/log';
import modelTemplate from './models/template';
import modelProductTypePool from './models/productTypePool';
import modelCard from './models/card';
import modelDepots from './models/depots';
import modelCategory from './models/category';
import modelAttribute from './models/attribute';
import modelProductType from './models/productType';
import modelOrder from './models/order';
import modelCheckCode from './models/checkCode';
import modelTransactionPoint from './models/transactionPoint';
import modelPointUser from './models/pointUser';
import modelEmployees from './models/employees';
import modelMappingRoles from './models/mappingRoles';
import modelRoles from './models/roles';
import modelUserPartners from './models/userPartners';
import modelVoucherPools from './models/voucherPools';
import modelConditions from './models/conditions';
import modelFileImport from './models/fileImport';
import modelCodes from './models/codes';
import modelUserVouchers from './models/userVouchers';
import modelStores from './models/stores';
import modelUsers from './models/users';


const app = dva({
  history: require('history').createHashHistory()
});

app.use(createLoading('loading'));

app.model(modelGlobal);
app.model(modelMenu);
app.model(modelSetting);
app.model(modelAuth);
app.model(modelUser);
app.model(modelProduct);
app.model(modelVouchers);
app.model(modelImport)
app.model(modelGroup);
app.model(modelCategories);
/* PLOP_INJECT_EXPORT */
app.model(modelModel);
app.model(modelAction);
app.model(modelConfig);
app.model(modelCronLogs);
app.model(modelCron);
app.model(modelLog);
app.model(modelTemplate);
app.model(modelProductTypePool);
app.model(modelCard);
app.model(modelDepots);
app.model(modelCategory);
app.model(modelProductType);
app.model(modelOrder);
app.model(modelCheckCode);
app.model(modelTransactionPoint);
app.model(modelPointUser);
app.model(modelEmployees);
app.model(modelMappingRoles);
app.model(modelRoles);
app.model(modelUserPartners);
app.model(modelVoucherPools);
app.model(modelConditions);
app.model(modelFileImport);
app.model(modelCodes);
app.model(modelUserVouchers);
app.model(modelStores);
app.model(modelPartners);
app.model(modelUsers);
app.model(modelBanner);
app.model(modelAttribute);
app.router(require('./App').default);

app.start('#root');

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

export default app;
